import React, { PureComponent } from 'react';

import SellPaymentsModal from './SellPaymentsModal';
import rules from "../../../../../components/Forms/rules";
import enums from "../../../../../constants/enums";
import CardLink from '../@components/CardLink';

class SellPaymentsPanelView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const { sellPaymentsModalActive, availablePayments, channels } = this.props;
    const total = (channels && channels
      .filter(channel => channel.status !== 'fraud')
      .reduce((aggregate, nextValue) => aggregate + nextValue.value, 0)) || 0;
    const totalAvailable = (availablePayments && availablePayments
      .filter(payment => payment.status !== 'fraud')
      .reduce((aggregate, nextValue) => aggregate + nextValue.remainingValue, 0)) || 0;
    return (
      <div>
        <div className="payments">
          <div className="title">Delivered Payments</div>
          <table>
            <thead>
            <tr>
              <th>Code</th>
              <th>Pin</th>
              <th>Type</th>
              <th>Status</th>
              <th>Value</th>
              <th>Sent Value</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {channels && channels.map((channel, i)=>{
              const payment = channel.payment;
              return (
                <tr key={i} className={channel.status}>
                  <td><CardLink type={payment.type} code={payment.code} pin={payment.pin} /></td>
                  <td>{payment.pin}</td>
                  <td>{payment.type}</td>
                  <td>{(enums.paymentStatusMap[payment.status] || {}).label}</td>
                  <td>{payment.value}</td>
                  <td>{channel.value}</td>
                  <td>
                    <div className="action-buttons">
                      {channel.status !== 'fraud' && (
                        <button type="button" onClick={() => this.props.setAsFraud(channel)}>Set As Fraud</button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan="7" className="totals">
                Total (non fraud): ${total}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div className="payments">
          <div className="title">Selected Payments</div>
          <table>
            <thead>
            <tr>
              <th>Code</th>
              <th>Pin</th>
              <th>Type</th>
              <th>Status</th>
              <th>Value</th>
              <th>Remaining</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {availablePayments && availablePayments.map((payment, i)=>(
              <tr key={i}>
                <td><CardLink type={payment.type} code={payment.code} pin={payment.pin} /></td>
                <td>{payment.pin}</td>
                <td>{payment.type}</td>
                <td>{(enums.paymentStatusMap[payment.status] || {}).label}</td>
                <td>{payment.value}</td>
                <td>{payment.remainingValue}</td>
                <td>
                  {this.props.sendingPayments.indexOf(payment._id) > -1 ? (
                    <span>sending ...</span>
                  ) : (
                    <div className="action-buttons">
                      <button type="button" onClick={() => this.props.sendSellPayment(payment._id)}>Send</button>

                      {payment.status !== 'fraud' && (
                        <button type="button" onClick={() => this.props.setPaymentAsFraud(payment)}>Set As Fraud</button>
                      )}
                      <button
                        type="button"
                        onClick={() => this.props.togglePayment({ checked: false, _id: payment._id})}
                      >x</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}

            <tr>
              <td colSpan="7" className="totals">
                Total: ${totalAvailable}(Selected) + ${total}(Paid) =  ${totalAvailable + total}
              </td>
            </tr>


            </tbody>
          </table>
          <div className="actions">
            <button className="button" type="button" onClick={this.props.openSellPaymentsModal}>+</button>
          </div>
        </div>
        {sellPaymentsModalActive && (
          <SellPaymentsModal
            trade={this.props.trade}
            selectedPayments={this.props.selectedPayments}
            togglePayment={this.props.togglePayment}
            onFilterChange={this.props.onFilterChange}
            total={total}
            totalAvailable={totalAvailable}
          />
        )}
      </div>
    )
  }
}

export default SellPaymentsPanelView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsPanel.view.js